import { createEnvironment } from './environment.model';
import { ORIGIN_V2_API, ORIGIN_V2_APP } from './_origin';

export const environment = createEnvironment({
  production: true,
  name: 'v2',
  encryptionStorage: 'aes',
  sentry: {
    sampleRate: 1.0,
  },
  origin: {
    app: ORIGIN_V2_APP,
    api: ORIGIN_V2_API,
  },
  msal: {
    clientId: 'a2190b6a-fcef-46cb-a5ed-f944c3e4e163',
    authority: 'https://login.microsoftonline.com/17b90855-d3b5-42a2-82de-8bdc8d93224d',
    redirectUri: `${ORIGIN_V2_APP}/auth/login`,
  },
  devLogin: true,
});
